import React, { useContext, useEffect, useState } from "react";
import { Container, Table, Button, Row, Col, Input } from "reactstrap";
import Header from "../../components/Headers/Header";
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import AdminNavbar from "../../components/Navbars/AdminNavbar/AdminNavbar";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import useHistory, { HistoryType } from "../../context/hooks/useHistory";
import { AuthContext } from "../../context/AuthContext";
import { EmpresasContext } from "../../context/EmpresasContext";
import ModalHistory from "../../components/ModalHistory/ModalHistory";

const PresentationHistory = () => {
    const { getAllHistories, historiesList, getPresentationByNetwork, getAllHistoriesPaged, getPresentationHtmlByNetwork, pageCount } = useHistory();
    const { getNetworkByUserId } = useContext(EmpresasContext);
    const [loading, setLoading] = useState(false);
    const [histories, setHistories] = useState<HistoryType[]>([]);
    const { objUserTk } = useContext(AuthContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataSearch, setDataSearch] = useState({ network: "" });
    const [fetchNetwork, setFetchNetwork] = useState<string | undefined>("");
    const [modalOpen, setModalOpen] = useState(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [networkLoaded, setNetworkLoaded] = useState(false);

    // useEffect(() => {
    //     async function fetchHistories() {
    //         setLoading(true);
    //         try {
    //             // await getAllHistories();
    //             const fetchNetwork_teste = await getNetworkByUserId(objUserTk.UserId);
    //             setFetchNetwork(fetchNetwork_teste);
    //             getAllHistoriesPaged(1, fetchNetwork)
    //                 .then(data => {
    //                     setHistories(data || []);
    //                     setLoading(false);
    //                 })
    //                 .catch(error => {
    //                     console.error("Erro ao buscar usuários:", error);
    //                     setLoading(false);
    //                 });
    //             setLoading(false);
    //         } catch (error) {
    //             setLoading(false);
    //             console.error("Erro ao buscar históricos:", error);
    //         }
    //     }
    //     fetchHistories();
    // }, [fetchNetwork]);

    useEffect(() => {
        const fetchHistories = async () => {
            setLoading(true);
            try {
                const fetchNetwork_teste = await getNetworkByUserId(objUserTk.UserId);
                setFetchNetwork(fetchNetwork_teste);
    
                const data = await getAllHistoriesPaged(1, fetchNetwork_teste);
                setHistories(data || []);
            } catch (error) {
                console.error("Erro ao buscar históricos:", error);
            } finally {
                setLoading(false);
            }
        };
    
        fetchHistories();
    }, []);
    
    const onChangePaginationCommon = async (e: any, value: any) => {

        await getAllHistoriesPaged(value, fetchNetwork);
    };

    const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setCurrentPage(1);
        setLoading(true);
        getAllHistoriesPaged(1, fetchNetwork)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, network: e.target.value });
    };

    const handleDownload = async (id: number) => {
        const base64Data = await getPresentationByNetwork(id);
        if (base64Data) {
            const fileName = "presentation.pdf";
            const linkSource = base64Data;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    const handlePresent = async (id: number) => {
        setLoading(true);
        try {
            const htmlContent = await getPresentationHtmlByNetwork(id);
            if (htmlContent) {
                setHtmlContent(htmlContent);
                setModalOpen(true);
            }
        } catch (error) {
            console.error("Erro ao carregar a apresentação HTML:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <LoadingSpinner />}
            <Header />
            <AdminNavbar brandText={"Histórico de relatórios"} search={false} titleSearch={""} />
            <Container className="mt-4">
                {/* <Row>
                    <Col xs="6">
                        <form className="d-flex" onSubmit={handleSearchSubmit}>
                            <Input
                                className="form-control-alternative"
                                type="text"
                                name="search"
                                id="search"
                                placeholder="Buscar por rede"
                                value={dataSearch.network}
                                onChange={handleSearchChange}
                                style={{ width: "75%" }}
                            />
                            <Button style={{ color: "#FFF", backgroundColor: "#2c2c2c" }} type="submit" size="m">Buscar</Button>
                        </form>
                    </Col>
                </Row> */}
                <Row className="mt-4">
                    <Col>
                        <div className="table-responsive">
                            <Table style={{ tableLayout: 'fixed', width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Rede</th>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Data de Criação</th>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Tipo de Arquivo</th>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Visualizado</th>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historiesList.map((histories, index) => (
                                        <tr key={index}>
                                            <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{histories.network}</td>
                                            <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{histories.createdData}</td>
                                            <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {histories.historyType === 0 || histories.historyType === null ? 'Consolidação' : 'Apresentação'}
                                            </td>
                                            <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{histories.viewingDate ? `Visualizado em: ${histories.viewingDate}` : 'Não visualizado'}</td>
                                            {/* <td className="actions-column">
                                                <Button onClick={() => handleDownload(histories.id)} style={{ color: "#FFF", backgroundColor: "#2c2c2c" }}>
                                                    Baixar
                                                </Button>
                                            </td> */}
                                            <td className="actions-column">
                                                {histories.historyType === 0 || histories.historyType === null ? (
                                                    <Button
                                                        onClick={() => handleDownload(histories.id)}
                                                        style={{ color: "#FFF", backgroundColor: "#2c2c2c" }}
                                                    >
                                                        Baixar
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        onClick={() => handlePresent(histories.id)}
                                                        style={{ color: "#FFF", backgroundColor: "#007bff" }}
                                                    >
                                                        Apresentar
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                            {pageCount && (
                                <div className="d-flex justify-content-center mt-4">
                                    <PaginationMaterial
                                        onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                        count={pageCount}
                                    />
                                </div>
                            )}
                            {historiesList.length === 0 && (
                                <div style={{ color: "red" }}>ENCONTRADO NENHUM REGISTRO</div>
                            )}
                        </div>
                    </Col>
                </Row>

                {/* <Table striped>
                    <thead>
                        <tr>
                            <th>Rede</th>
                            <th>Data de Criação</th>
                            <th>Visualizado</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {histories.map(history => (
                            <tr key={history.id}>
                                <td>{history.network}</td>
                                <td>{history.createdData}</td>
                                <td>{history.viewingDate ? `Visualizado em: ${history.viewingDate}` : 'Não visualizado'}</td>
                                <td>
                                    <Button onClick={() => handleDownload(history.id)} style={{ color: "#FFF", backgroundColor: "#2c2c2c" }}>
                                        Baixar
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table> */}
                <ModalHistory
                    open={modalOpen}
                    handleClose={() => setModalOpen(false)}
                    htmlContent={htmlContent}
                />
            </Container>
        </>
    );
};

export default PresentationHistory;
